import {
  ActivateRetailConsoleAsDevKitUrl,
  GetVerifiableCredentials,
  partnerSupportResourceUrls,
} from "./urls";

export type AssistantDocLink = Readonly<{ titleKey: string; descriptionKey: string; url: string }>;
export type AssistantStageContent = Readonly<{
  suggestionKeys: string[];
  docs: AssistantDocLink[];
}>;

const environmentDoc: AssistantDocLink = {
  titleKey: "hubSupportDocEnvironmentTitle",
  descriptionKey: "hubSupportDocEnvironmentDescription",
  url: partnerSupportResourceUrls.gdkDocs,
};
const shipDoc: AssistantDocLink = {
  titleKey: "hubSupportDocShipTitle",
  descriptionKey: "hubSupportDocShipDescription",
  url: partnerSupportResourceUrls.devDocs,
};
const partnerCenterDoc: AssistantDocLink = {
  titleKey: "supportAssistant_docPartnerCenterTitle",
  descriptionKey: "supportAssistant_docPartnerCenterDescription",
  url: GetVerifiableCredentials,
};
const devkitDoc: AssistantDocLink = {
  titleKey: "supportAssistant_docDevkitTitle",
  descriptionKey: "supportAssistant_docDevkitDescription",
  url: ActivateRetailConsoleAsDevKitUrl,
};
const certificationDoc: AssistantDocLink = {
  titleKey: "hubSupportDocCertificationTitle",
  descriptionKey: "hubSupportDocCertificationDescription",
  url: partnerSupportResourceUrls.devDocs,
};

const defaultContent: AssistantStageContent = {
  suggestionKeys: [
    "supportAssistant_suggestionXboxLiveSettings",
    "supportAssistant_suggestionWhatsNext",
    "supportAssistant_suggestionGetStarted",
  ],
  docs: [environmentDoc, shipDoc],
};

// Keyed by the stage GET /home returns (Nexus HubAssistant OnboardingStageRules.cs);
// "unknown" and anything else use defaultContent.
const stageContent: Readonly<Record<string, AssistantStageContent>> = {
  ndaPending: {
    suggestionKeys: [
      "supportAssistant_suggestionNda",
      "supportAssistant_suggestionWhatsNext",
      "supportAssistant_suggestionGetStarted",
    ],
    docs: [environmentDoc, shipDoc],
  },
  partnerCenter: {
    suggestionKeys: [
      "supportAssistant_suggestionPartnerCenter",
      "supportAssistant_suggestionWhatsNext",
      "supportAssistant_suggestionXboxLiveSettings",
    ],
    docs: [partnerCenterDoc, environmentDoc],
  },
  idXboxApplication: {
    suggestionKeys: [
      "supportAssistant_suggestionWhatsNext",
      "supportAssistant_suggestionGetStarted",
      "supportAssistant_suggestionPartnerCenter",
    ],
    docs: [environmentDoc, shipDoc],
  },
  conceptRequired: {
    suggestionKeys: [
      "supportAssistant_suggestionConceptReview",
      "supportAssistant_suggestionWhatsNext",
      "supportAssistant_suggestionGetStarted",
    ],
    docs: [environmentDoc, shipDoc],
  },
  conceptNeedsInfo: {
    suggestionKeys: [
      "supportAssistant_suggestionConceptNeedsInfo",
      "supportAssistant_suggestionWhatsNext",
      "supportAssistant_suggestionGetStarted",
    ],
    docs: [environmentDoc, shipDoc],
  },
  conceptPending: {
    suggestionKeys: [
      "supportAssistant_suggestionConceptReview",
      "supportAssistant_suggestionXboxLiveSettings",
      "supportAssistant_suggestionGetStarted",
    ],
    docs: [environmentDoc, shipDoc],
  },
  contracts: {
    suggestionKeys: [
      "supportAssistant_suggestionWhatsNext",
      "supportAssistant_suggestionTitleId",
      "supportAssistant_suggestionCertification",
    ],
    docs: [certificationDoc, shipDoc],
  },
  devHardware: {
    suggestionKeys: [
      "supportAssistant_suggestionDevkit",
      "supportAssistant_suggestionXboxLiveSettings",
      "supportAssistant_suggestionTitleId",
    ],
    docs: [devkitDoc, environmentDoc],
  },
};

export const getAssistantStageContent = (stage: string | undefined): AssistantStageContent =>
  stage && Object.hasOwn(stageContent, stage) ? stageContent[stage] : defaultContent;
